import moment from 'moment';
import 'moment/locale/en-gb';

const workingHoursPerday = 8;

const publicHolidays = [
	'2022-11-07',
	'2022-11-08',
	'2022-11-09',
	'2023-01-01',
	'2023-01-07',
	'2023-03-08',
	'2023-04-14',
	'2023-04-15',
	'2023-04-16',
	'2023-05-01',
	'2023-05-04',
	'2023-05-08',
	'2023-05-14',
	'2023-06-18',
	'2023-09-24',
	'2023-10-13',
	'2023-10-14',
	'2023-10-15',
	'2023-10-29',
	'2023-11-09',
	'2023-11-26',
	'2023-11-27',
	'2023-11-28',
	'2024-01-01',
	'2024-01-07',
	'2024-03-08',
	'2024-04-13',
	'2024-04-14',
	'2024-04-15',
	'2024-04-16',
	'2024-05-01',
	'2024-05-14',
	'2024-05-22',
	'2024-05-26',
	'2024-06-18',
	'2024-09-24',
	'2024-10-01',
	'2024-10-02',
	'2024-10-03',
	'2024-10-15',
	'2024-10-29',
	'2024-11-09',
	'2024-11-14',
	'2024-11-15',
	'2024-11-16',
	'2024-12-29',
	'2025-01-01',
	'2025-01-07',
	'2025-03-08',
	'2025-04-14',
	'2025-04-15',
	'2025-04-16',
	'2025-05-01',
	'2025-05-11',
	'2025-05-14',
	'2025-05-15',
	'2025-06-18',
	'2025-09-21',
	'2025-09-22',
	'2025-09-23',
	'2025-09-24',
	'2025-10-15',
	'2025-10-29',
	'2025-11-04',
	'2025-11-05',
	'2025-11-06',
	'2025-11-09',
	'2025-12-29',
	'2026-01-01',
	'2026-01-07',
	'2026-03-08',
	'2026-04-14',
	'2026-04-15',
	'2026-04-16',
	'2026-05-01',
	'2026-05-05',
	'2026-05-14',
	'2026-06-18',
	'2026-09-24',
	'2026-10-10',
	'2026-10-11',
	'2026-10-12',
	'2026-10-15',
	'2026-10-29',
	'2026-11-09',
	'2026-11-23',
	'2026-11-24',
	'2026-11-25',
	'2026-12-29',
];

const holidays = [
	...publicHolidays.map((hd) => hd.replace('xxxx', moment().get('years') - 1)),
	...publicHolidays.map((hd) => hd.replace('xxxx', moment().get('years'))),
	...publicHolidays.map((hd) => hd.replace('xxxx', moment().get('years') + 1)),
];

export function getWorkingDays(from, to) {
	let totalHours = 0;
	const start = moment(from);
	const end = moment(to);
	const holidaySet = new Set(holidays);
	const current = start.clone().startOf('day');
	let excludedHolidays = [];
	while (current.isSameOrBefore(end, 'day')) {
		const dayOfWeek = current.day();
		const dateKey = current.format('YYYY-MM-DD');
		const isWeekendDay = dayOfWeek === 0 || dayOfWeek === 6;
		const isHolday = holidaySet.has(dateKey);
		if (!isWeekendDay && !isHolday) {
			const workStart = current.clone().hour(8).minute(0).second(0);
			const workEnd = current.clone().hour(16).minute(0).second(0);
			const effectiveStart = moment.max(workStart, start);
			const effectiveEnd = moment.min(workEnd, end);
			if (effectiveEnd.isAfter(effectiveStart)) {
				totalHours += effectiveEnd.diff(effectiveStart, 'hours', true);
			}
		}
		if (!isWeekendDay && isHolday) excludedHolidays.push(dateKey);
		current.add(1, 'day');
	}
	return { count: totalHours / workingHoursPerday, excludedHolidays };
}
